<div *ngIf="selectedValue || displayList.length > 0" class="cnpj-selector-dropdown">
  <button 
    class="selector-btn" 
    [class.active]="isDropdownOpen"
    [class.has-multiple]="displayList.length > 1"
    [class.no-cnpj-selected]="!selectedValue"
    [class.is-loading]="isLoading"
    [disabled]="isLoading"
    (click)="toggleDropdown()"
  >
    <span *ngIf="!selectedValue" class="warning-icon mdn-Icon-triangulo-exclamacao" aria-hidden="true"></span>
    <span *ngIf="selectedValue" class="mdn-Icon-empresa mdn-Icon--md" [attr.aria-label]="'components.cnpjSelector.ariaLabelCompany' | i18n"></span>
    <span class="selector-text">
      <ng-container *ngIf="selectedValue">
        <ng-container *ngIf="isFixaMode; else cnpjFormat">
          {{ fixaContractLabel(selectedValue) }}
        </ng-container>
        <ng-template #cnpjFormat>
          {{ selectedValue | cnpj }}
        </ng-template>
      </ng-container>
      <ng-container *ngIf="!selectedValue">
        {{ isFixaMode ? 'Selecione um contrato' : 'Selecione um CNPJ' }}
      </ng-container>
    </span>
    
    <span *ngIf="isLoading" class="selector-spinner" aria-hidden="true"></span>
    <span *ngIf="!isLoading" class="dropdown-icon mdn-Icon-baixo" aria-hidden="true"></span>
  </button>
  
  <div class="dropdown-menu" [class.open]="isDropdownOpen" [class.has-scroll]="displayList.length > 4">
    <div class="dropdown-section">
      <div 
        *ngFor="let item of displayList" 
        class="dropdown-item"
        [class.selected]="item === selectedValue"
        [class.is-disabled]="isLoading"
        (click)="onSelectCnpj(item)"
      >
        <span class="cnpj-number">
          <strong>
            <ng-container *ngIf="isFixaMode; else cnpjDisplay">
              {{ fixaContractLabel(item) }}
            </ng-container>
            <ng-template #cnpjDisplay>
              {{ item | cnpj }}
            </ng-template>
          </strong>
          <span *ngIf="companyName" class="company-name"> - {{ companyName }}</span>
          <span *ngIf="isFixaMode && fixaContractByCustomerAccountId(item)?.status as st" class="contract-status" [class.status-active]="st === 'ACTIVE'">
            ({{ st }})
          </span>
        </span>
      </div>
    </div>
  </div>
</div>